export class SimpleEmitter<T> {
    private _observers: Array<(value: T) => void> = [];
    public onEmit(observer: (value: T) => void) {
        this._observers.push(observer);
    }
    public emit(value: T) {
        this._observers.map(observer => observer(value));
    }
}
